import React from 'react';
import { Gift, ArrowRight, CheckCircle2 } from 'lucide-react';

const FinalCTASection = () => {
  return (
    <section className="relative bg-black py-20 sm:py-24 lg:py-28" data-testid="final-cta-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="rounded-3xl border border-gold-500/30 bg-gradient-to-br from-zinc-950 via-black to-zinc-950 px-6 py-7 sm:px-10 sm:py-9 shadow-[0_20px_80px_-30px_rgba(212,175,55,0.45)] ring-1 ring-gold-500/10">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-center">
            <div className="lg:col-span-5 flex items-center gap-4">
              <div className="w-14 h-14 rounded-2xl bg-gold-500/10 border border-gold-500/30 flex items-center justify-center flex-shrink-0">
                <Gift className="w-6 h-6 text-gold-300" />
              </div>
              <div>
                <h3 className="text-2xl sm:text-3xl font-extrabold text-white tracking-tight">Start Free Today</h3>
                <p className="text-sm text-white/60 mt-1">Join thousands of restaurants saving more with NoFee.</p>
              </div>
            </div>

            <div className="lg:col-span-4 flex flex-wrap gap-x-5 gap-y-2 justify-center lg:justify-start text-sm">
              {['No contracts', 'No hidden fees', 'Cancel anytime'].map(t => (
                <div key={t} className="inline-flex items-center gap-1.5 text-white/70">
                  <CheckCircle2 className="w-4 h-4 text-gold-400" /> {t}
                </div>
              ))}
            </div>

            <div className="lg:col-span-3 flex lg:justify-end">
              <a
                href="/start?plan=ordering"
                data-testid="final-cta-button"
                className="group inline-flex items-center justify-center gap-2 px-7 py-4 bg-gold-500 hover:bg-gold-400 text-black font-bold rounded-2xl transition-all hover:shadow-2xl hover:shadow-gold-500/40 hover:-translate-y-0.5 text-base sm:text-lg w-full lg:w-auto"
              >
                Start Free Today
                <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTASection;
